import React from 'react';
import './styles/seoside.css';
import SEO from '../../components/SEO';
import Header from '../../components/header';
import Footer from '../../components/footer';
import ArtikelSektion from '../../components/artikelsektion';
import Testimonials from '../../components/testimonials';
import SEOFAQ from '../../components/SEOFAQ';
import CTAKnap, { CTAIkoner } from '../../components/ctaknap';

const SEOHero = () => {
  return (
    <section className="seo-hero">
      <div className="container">
        <div className="seo-hero-content">
          <div className="seo-hero-text">
            <div className="seo-hero-badge">
              <span>SEO & Søgemaskineoptimering</span>
            </div>
            <h1 className="seo-hero-title">
              <span className="seo-hero-accent">Synlighed på Google</span> er ikke en tilfældighed
            </h1>
            <p className="seo-hero-description">
              Den bedste hjemmeside i verden er uden værdi, hvis ingen ser den. I et konkurrencefyldt digitalt landskab er det ikke nok at håbe på at blive fundet – det kræver en bevidst og strategisk indsats.
              <br /><br />
              Søgemaskineoptimering (SEO) er den indsats. Det er det metodiske håndværk, der sikrer, at jeres virksomhed bliver matchet med de kunder, der aktivt leder efter jeres løsninger online.
            </p>
            <div className="seo-hero-stats">
              <div className="seo-hero-stat">
                <div className="seo-hero-stat-number">50+</div>
                <div className="seo-hero-stat-label">Succesfulde Partnerskaber</div>
              </div>
              <div className="seo-hero-stat">
                <div className="seo-hero-stat-number">6-12. mdr</div>
                <div className="seo-hero-stat-label">Til Målbar Effekt</div>
              </div>
              <div className="seo-hero-stat">
                <div className="seo-hero-stat-number">100% Dansk</div>
                <div className="seo-hero-stat-label">Ekspertise i Dit Marked</div>
              </div>
            </div>
            <div className="seo-hero-actions">
              <CTAKnap 
                variant="primary" 
                size="large"
                href="/kontakt"
                icon={<CTAIkoner.ArrowRight />}
              >
                Få en snak om SEO
              </CTAKnap>
              <CTAKnap 
                variant="outline" 
                size="large"
                href="/priser#prisudregner"
                icon={<CTAIkoner.BarChart />}
              >
                Se priser
              </CTAKnap>
            </div>
          </div>
          <div className="seo-hero-visual">
            <div className="seo-hero-image">
              <div className="seo-hero-mockup">
                <div className="google-search-window">
                  <div className="search-top">
                    <div className="google-logo">Google</div>
                    <div className="search-bar">
                      <span>din virksomhed + lokalområde</span>
                    </div>
                  </div>
                  <div className="search-results">
                    <div className="search-result featured">
                      <div className="result-url">www.dinvirksomhed.dk</div>
                      <div className="result-title">Din Virksomhed - Lokalt i [By]</div>
                      <div className="result-description">Professionel service i dit lokalområde...</div>
                      <div className="result-position">#1</div>
                    </div>
                    <div className="search-result">
                      <div className="result-url">konkurrent1.dk</div>
                      <div className="result-title">Konkurrent 1</div>
                      <div className="result-description">Lorem ipsum dolor sit amet...</div>
                      <div className="result-position">#2</div>
                    </div>
                    <div className="search-result">
                      <div className="result-url">konkurrent2.dk</div>
                      <div className="result-title">Konkurrent 2</div>
                      <div className="result-description">Consectetur adipiscing elit...</div>
                      <div className="result-position">#3</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const SEOFeatures = () => {
  return (
    <section className="seo-value-proposition">
      <div className="container">
        <div className="seo-value-header">
          <h2 className="seo-value-title">
            Gør jeres platform synlig for de rigtige kunder
          </h2>
          <p className="seo-value-subtitle">
            Jeres hjemmeside er bygget til at imponere de besøgende, den får. Vores SEO-service er designet til at sikre, at den får de rigtige besøgende til at starte med.
            <br /><br />
            Søgemaskineoptimering er et specialiseret håndværk, der fokuserer på ét mål: at positionere jeres virksomhed foran konkurrenterne på Google. Det er et aktivt tilvalg for virksomheder, der ser deres online tilstedeværelse som en afgørende kanal for vækst.
          </p>
        </div>
        
        <div className="seo-value-content">
          <div className="seo-value-visual">
            <div className="ranking-demonstration">
              <div className="search-result-example">
                <div className="search-bar-demo">
                  <span>din branche + dit område</span>
                </div>
                <div className="search-results-demo">
                  <div className="result-item featured">
                    <div className="result-title">Din Virksomhed</div>
                    <div className="result-url">www.dinvirksomhed.dk</div>
                    <div className="result-snippet">Professionel service i [dit område]...</div>
                  </div>
                  <div className="result-item">
                    <div className="result-title">Konkurrent 1</div>
                    <div className="result-url">konkurrent.dk</div>
                  </div>
                  <div className="result-item">
                    <div className="result-title">Konkurrent 2</div>
                    <div className="result-url">anden-konkurrent.dk</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div className="seo-value-points">
            <div className="value-point">
              <div className="value-icon">
                <CTAIkoner.Search />
              </div>
              <div className="value-content">
                <h3>Målrettet keyword research</h3>
                <p>Vi finder de søgeord dine kunder faktisk bruger</p>
              </div>
            </div>
            <div className="value-point">
              <div className="value-icon">
                <CTAIkoner.BarChart />
              </div>
              <div className="value-content">
                <h3>Teknisk optimering</h3>
                <p>Din hjemmeside bliver hurtigere og mere søgevenlig</p>
              </div>
            </div>
            <div className="value-point">
              <div className="value-icon">
                <CTAIkoner.FileText />
              </div>
              <div className="value-content">
                <h3>Relevant indhold</h3>
                <p>Tekster der hjælper både Google og dine besøgende</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const SEOProcess = () => {
  return (
    <section className="seo-methodology">
      <div className="container">
        <div className="seo-methodology-header">
          <h2 className="seo-methodology-title">
            Vores SEO tilgang: Fra teori til resultater
          </h2>
          <p className="seo-methodology-subtitle">
            Vi kombinerer dataanalyse med praktisk erfaring
          </p>
        </div>
        
        <div className="methodology-showcase">
          <div className="methodology-visual">
            <div className="seo-dashboard-mockup">
              <div className="dashboard-header">
                <div className="dashboard-title">SEO Resultat Rapport</div>
                <div className="dashboard-mockup-note">*Eksempel på resultat rapport</div>
                <div className="dashboard-date">Måned 6</div>
              </div>
              <div className="dashboard-metrics">
                <div className="metric-card">
                  <div className="metric-label">Organisk trafik</div>
                  <div className="metric-value">+127%</div>
                  <div className="metric-trend up">↗</div>
                </div>
                <div className="metric-card">
                  <div className="metric-label">Rankings top 10</div>
                  <div className="metric-value">23</div>
                  <div className="metric-trend up">↗</div>
                </div>
                <div className="metric-card">
                  <div className="metric-label">Nye leads</div>
                  <div className="metric-value">+89%</div>
                  <div className="metric-trend up">↗</div>
                </div>
              </div>
              <div className="dashboard-chart">
                <div className="chart-bars">
                  <div className="bar" style={{height: '20%'}}></div>
                  <div className="bar" style={{height: '35%'}}></div>
                  <div className="bar" style={{height: '45%'}}></div>
                  <div className="bar" style={{height: '60%'}}></div>
                  <div className="bar" style={{height: '75%'}}></div>
                  <div className="bar" style={{height: '90%'}}></div>
                </div>
                <div className="chart-labels">
                  <span>Måned 1</span>
                  <span>Måned 6</span>
                </div>
              </div>
            </div>
          </div>
          
          <div className="methodology-approach">
            <div className="approach-intro">
              <h3>Hvad gør forskellen?</h3>
              <p>I stedet for generiske SEO løsninger, fokuserer vi på hvad der virker specifikt for din branche og dit lokale marked.</p>
            </div>
            
            <div className="approach-points">
              <div className="approach-point">
                <div className="point-marker">→</div>
                <div className="point-content">
                  <strong>Lokal konkurrentanalyse:</strong> Vi studerer hvad dine lokale konkurrenter gør rigtigt (og forkert)
                </div>
              </div>
              
              <div className="approach-point">
                <div className="point-marker">→</div>
                <div className="point-content">
                  <strong>Branchespecifik keyword research:</strong> Søgeord der faktisk konverterer i din branche
                </div>
              </div>
              
              <div className="approach-point">
                <div className="point-marker">→</div>
                <div className="point-content">
                  <strong>Teknisk optimering der matcher <a href="https://developers.google.com/search/docs/fundamentals/seo-starter-guide" target="_blank" rel="noopener noreferrer">Google's krav</a>:</strong> Hastighed, mobile-venlighed og brugeroplevelse
                </div>
              </div>
              
              <div className="approach-point">
                <div className="point-marker">→</div>
                <div className="point-content">
                  <strong>Indhold der svarer på kunders spørgsmål:</strong> Vi skriver ikke for Google, men for mennesker der søger hjælp
                </div>
              </div>
            </div>
            
            <div className="approach-timeline">
              <div className="timeline-note">
                <div className="timeline-icon">
                  <CTAIkoner.Clock />
                </div>
                <div className="timeline-text">
                  <strong>Realistisk tidsramme:</strong> De første forbedringer ses efter 2-3 måneder. Betydelige resultater efter 6-12 måneder.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const SEOWebsitePromo = () => {
  return (
    <section className="seo-website-promo">
      <div className="container">
        <div className="seo-website-promo-content">
          <div className="seo-website-promo-text">
            <h2 className="seo-website-promo-title">
              Mangler du en <span className="seo-website-promo-accent">hjemmeside?</span>
            </h2>
            <p className="seo-website-promo-description">
              SEO virker bedst når din hjemmeside er bygget rigtigt fra starten. Vi laver moderne, 
              hurtige hjemmesider der er optimeret for søgemaskiner og konverterer besøgende til kunder.
            </p>
            <div className="seo-website-promo-benefits">
              <div className="promo-benefit">
                <div className="promo-benefit-icon">
                  <CTAIkoner.Check />
                </div>
                <span>SEO-optimeret fra start</span>
              </div>
              <div className="promo-benefit">
                <div className="promo-benefit-icon">
                  <CTAIkoner.Check />
                </div>
                <span>Hurtig loading og mobil-venlig</span>
              </div>
              <div className="promo-benefit">
                <div className="promo-benefit-icon">
                  <CTAIkoner.Check />
                </div>
                <span>Professionelt design der konverterer</span>
              </div>
            </div>
            <div className="seo-website-promo-actions">
              <CTAKnap 
                variant="primary" 
                size="large"
                href="/hjemmesider"
                icon={<CTAIkoner.ArrowRight />}
              >
                Hjemmesider
              </CTAKnap>
              <CTAKnap 
                variant="outline" 
                size="large"
                href="/priser#prisudregner"
                icon={<CTAIkoner.FileText />}
              >
                Få et tilbud
              </CTAKnap>
            </div>
          </div>
          <div className="seo-website-promo-visual">
            <div className="website-elements-grid">
              <div className="element-card header-element">
                <div className="element-bar"></div>
                <div className="element-content">
                  <div className="element-line short"></div>
                  <div className="element-line medium"></div>
                </div>
              </div>
              <div className="element-card hero-element">
                <div className="element-badge"></div>
                <div className="element-title"></div>
                <div className="element-subtitle"></div>
                <div className="element-button"></div>
              </div>
              <div className="element-card feature-element">
                <div className="element-icon"></div>
                <div className="element-text">
                  <div className="element-line short"></div>
                  <div className="element-line long"></div>
                </div>
              </div>
              <div className="element-card content-element">
                <div className="element-content">
                  <div className="element-line long"></div>
                  <div className="element-line medium"></div>
                  <div className="element-line short"></div>
                </div>
              </div>
              <div className="element-card image-element">
                <div className="element-placeholder"></div>
              </div>
              <div className="element-card form-element">
                <div className="element-input"></div>
                <div className="element-input"></div>
                <div className="element-submit"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const SEOPage = () => {
  return (
    <>
      <SEO
        title="SEO der Giver Målbare Resultater for din Hjemmeside | Parla Branding"
        description="Gør jeres hjemmeside til jeres stærkeste salgskanal. Vi tilbyder målrettet SEO, der omsætter topplaceringer på Google til konkrete kundehenvendelser."
        keywords="målbare SEO resultater, Google topplaceringer, SEO salgskanal, konkrete kundehenvendelser, målrettet SEO, Google ranking"
        canonicalUrl="https://www.parlabranding.dk/seo"
        isService={true}
        serviceData={{
          name: "Professionel SEO & Søgemaskineoptimering",
          description: "Vi optimerer din hjemmeside for søgemaskiner og øger din online synlighed",
          price: "8000"
        }}
      />
      
      <Header />
      <SEOHero />
      <Testimonials />
      <SEOFeatures />
      <SEOProcess />
      <SEOWebsitePromo />
      <ArtikelSektion />
      <SEOFAQ />
      <Footer />
    </>
  );
};

export default SEOPage;